import React, { useRef } from 'react';

import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';

import NumberBox from '../../atoms/NumberBox';
import MainFont from '../../typography/mainFont';

import {
  CenterContainer,
  ChartLegend,
  ChartWrapper,
  DescriptiveLabel,
  DescriptiveLabelCorporate,
  DoughnutWrapper,
  GeneralLabel,
  Label
} from './style';

const defaultItem = ({ index, lab, data, colors }) => (
  <DescriptiveLabel key={index}>
    <GeneralLabel background={colors ? colors[index] : 'blue'}>
      <MainFont configuration={{ fontSize: 14 }}>
        {lab} {data[index]}
      </MainFont>
    </GeneralLabel>
  </DescriptiveLabel>
);

const dashboardSessions = ({ index, lab, data, colors }) => (
  <DescriptiveLabel>
    <Label background={colors ? colors[index] : 'blue'}>
      <MainFont configuration={{ fontSize: 14 }}>{lab}</MainFont>
    </Label>
    <NumberBox numberSize={24} bigNumber={data[index]} align="flex-start">
      <MainFont>
        {data[index]
          ? (
              (data[index] / data.reduce((acc, el) => acc + el, 0)) *
              100
            ).toFixed(2)
          : '-'}
        %
      </MainFont>
    </NumberBox>
  </DescriptiveLabel>
);

const chargersStatusPrivate = ({ index, lab, data }) => (
  <DescriptiveLabelCorporate key={index}>
    <Label background={index} private>
      <MainFont configuration={{ fontSize: 12 }}>
        {lab} ({data[index]})
      </MainFont>
    </Label>
  </DescriptiveLabelCorporate>
);

const chargersStatusCorporate = ({ index, lab, data }) => (
  <DescriptiveLabelCorporate key={index}>
    <Label background={index} private>
      <MainFont configuration={{ fontSize: 12 }}>
        {lab} ({data[index]})
      </MainFont>
    </Label>
  </DescriptiveLabelCorporate>
);

const legendItems = {
  dashboardSessions,
  defaultItem,
  chargersStatusPrivate,
  chargersStatusCorporate
};

const DoughnutChart = ({ dataset, doughnutStyle, item, title }) => {
  const { data = {}, labels } = dataset;
  const ref = useRef(null);

  if (!data.data || data.data.length === 0) {
    return <></>;
  }
  return (
    <DoughnutWrapper>
      <ChartWrapper>
        <Doughnut
          ref={ref}
          data={{
            labels,
            datasets: [data]
          }}
          options={doughnutStyle.options}
          //plugins={doughnutStyle.plugins} //TODO:TOFIX
        />
        <CenterContainer>
          <NumberBox bigNumber={data.data?.reduce((acc, el) => acc + el, 0)}>
            <MainFont configuration={{ fontSize: 12 }}>{title}</MainFont>
          </NumberBox>
        </CenterContainer>
      </ChartWrapper>
      <ChartLegend id="chartLegend">
        {labels?.map((lab, index) =>
          legendItems[item]({
            lab,
            index,
            data: data.data,
            colors: data.backgroundColor
          })
        )}
      </ChartLegend>
    </DoughnutWrapper>
  );
};

DoughnutChart.propTypes = {
  dataset: PropTypes.object,
  doughnutStyle: PropTypes.object,
  item: PropTypes.string,
  title: PropTypes.string
};

DoughnutChart.defaultProps = {
  dataset: {},
  item: 'defaultItem',
  doughnutStyle: {}
};

export default DoughnutChart;
